import { deserialiseToHTML, downloadAsAttachment } from '@api/HelperAPI';
import { fetchGetCreditCardDocumentsDownload } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useFetchCreditCardDocumentContent = ({
    documentId,
    signingState,
    fileFormat,
    enabled = true,
    suspense = true
}: {
    documentId: string;
    signingState: 'signed' | 'unsigned';
    fileFormat: 'html' | 'pdf';
    enabled?: boolean;
    suspense?: boolean;
}) => {
    const stateKey = useStateKey();

    const { data, refetch } = useQuery({
        queryKey: [
            'credit-card-document',
            stateKey,
            documentId,
            signingState,
            fileFormat
        ],
        queryFn: async () => {
            const responseData = await fetchGetCreditCardDocumentsDownload({
                documentId,
                signingState,
                stateKey,
                query: {
                    file_format: fileFormat
                }
            });

            if (fileFormat === 'html') {
                const [htmlData] = await deserialiseToHTML(responseData);
                return htmlData.data;
            }

            return downloadAsAttachment(responseData);
        },
        enabled: enabled,
        suspense: suspense
    });

    return { data: data, refetch };
};
